import styled from "styled-components";

import { colors } from "../../consts";
import { Paragraph2, WrapperContainer } from "../../components";

export const InfoText = styled(Paragraph2)`
  color: ${colors.RAISIN_70};

  b {
    font-weight: 700;
  }

  &:after {
    content: "|";
    padding-left: 16px;
  }

  &:last-of-type {
    &:after {
      content: "";
      padding-left: 0;
    }
  }
`;

export const UserInfoContainer = styled(WrapperContainer)`
  ${InfoText} {
    margin-right: 16px;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;
